var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"professional-personnel-page"},[_c('el-card',{staticClass:"page-card"},[_c('div',{staticClass:"card-header",attrs:{"slot":"header"},slot:"header"},[_c('h2',[_vm._v("职业人员")])]),_c('div',{staticClass:"page-content"},[_c('p',[_vm._v("职业人员页面内容")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }